import { Component } from '@angular/core';
import { RouterLink, RouterOutlet, RouterLinkActive } from '@angular/router';
@Component({
  selector: 'app-main-biologie',
  imports: [RouterLink, RouterOutlet, RouterLinkActive],
  templateUrl: './main-biologie.component.html',
  styleUrl: './main-biologie.component.scss'
})
export class MainBiologieComponent {}
